<template>
  <div v-if="loading" class="container d-flex jc-center m-y-6">
    <spinner size="100px"/>
  </div>
  <div v-else>
    <client-only>
      <pro-account v-if="isPro"/>
      <consumer-account v-else/>
    </client-only>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProAccount from './Pro';
import ConsumerAccount from './Consumer';

export default {
  name: 'account',
  components: {
    ProAccount,
    ConsumerAccount,
  },
  data () {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters('user', [
      'isPro',
    ]),
  },
  mounted () {
    // Render the spinner on server and client initially
    this.loading = false;
  },
};
</script>
